<div class="auth-shell">
  <aside class="auth-shell__branding">
    <div class="auth-shell__branding-inner">
      <div class="auth-shell__logo">
        <app-icon path="assets/images/common/white-logo.svg"></app-icon>
      </div>

      <div class="auth-shell__copy">
        <div class="heading">{{ currentContent.titleKey | translate }}</div>
        <p>{{ currentContent.descriptionKey | translate }}</p>

        @if (currentContent.highlights?.length) {
          <div class="auth-shell__highlights">
            @for (highlight of currentContent.highlights; track highlight) {
              <div class="auth-shell__highlight">{{ highlight | translate }}</div>
            }
          </div>
        }
      </div>

      <div class="auth-shell__footer">{{currentYear}} {{'partnerPortalFooter' | translate}}</div>
    </div>
  </aside>

  <section class="auth-shell__content">
    <div class="auth-shell__form-wrap">
      <router-outlet></router-outlet>
    </div>
  </section>
</div>
